export class PublicSearchFilter {
    name?: string;
    dateFrom?: Date;
    dateTo?: Date;
    status?: number;
    lengthFrom?: number;
    lengthTo?: number;
    sports?: number[];
    countries?: number[];
}

export function isFilterActive(filter: PublicSearchFilter): boolean {
    return !!(filter.name || filter.dateFrom || filter.dateTo || filter.status
        || filter.lengthFrom || filter.lengthTo
        || filter.sports?.length || filter.countries?.length);
}

export enum PublicSearchFilterQueryParams {
    NAME = 'name',
    SPORTS = 'sports',
    COUNTRIES = 'countries',
    STATUS = 'status',
    LENGTH_FROM = 'lengthFrom',
    LENGTH_TO = 'lengthTo',
    DATE_FROM = 'dateFrom',
    DATE_TO = 'dateTo'
}